import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AddParamsService, Params } from '../utilis/add-params-service';
import { Observable } from 'rxjs';
import { EndRidePhotos, Ride } from '../../models/ride';
import { environment } from '../../../environments/environment';
import { GenericPaginated } from '../../models/generic-paginated';
import { Generic } from '../../models/generic';
import { RideTrajectoryResponse } from '../../models/ride-trajectory';

@Injectable({
  providedIn: 'root'
})
export class RideService {

  private baseUrl = environment.url;

  private http = inject(HttpClient)
  private addParamsService = inject(AddParamsService)


  getRidesList(params?: Params): Observable<GenericPaginated<Ride>> {
    return this.http.get<GenericPaginated<Ride>>(`${this.baseUrl}/rides`, {
      params: this.addParamsService.addParams(params)
    });
  }

  getRideById = (rideId: string): Observable<Generic<Ride>> => {
    return this.http.get<Generic<Ride>>(`${this.baseUrl}/rides/${rideId}`);
  }

  endRide = (rideId: number, force = false): Observable<Ride> => {
    const url = force
      ? `${this.baseUrl}/rides/${rideId}/end?force=true`
      : `${this.baseUrl}/rides/${rideId}/end`;
    return this.http.post<Ride>(url, {});
  }

  approveEndRidePhotos = (rideId: number, payload: object = {}): Observable<Ride> => {
    return this.http.post<Ride>(`${this.baseUrl}/rides/${rideId}/photos/approve`, payload);
  }

  rejectEndRidePhotos = (rideId: number, payload: object): Observable<Ride> => {
    return this.http.post<Ride>(`${this.baseUrl}/rides/${rideId}/photos/reject`, payload);
  }

  getRideTrajectory(rideId: number): Observable<RideTrajectoryResponse> {
    return this.http.get<RideTrajectoryResponse>(`${this.baseUrl}/rides/${rideId}/trajectory`);
  }

  updatePhotoStatus = (rideId: number, payload: { status: string; rejectionReason?: string }): Observable<Ride> => {
    return this.http.post<Ride>(`${this.baseUrl}/rides/${rideId}/photos/status`, payload);
  }

  getEndRidePhotos(rideId: number): Observable<Generic<EndRidePhotos>> {
    return this.http.get<Generic<EndRidePhotos>>(`${this.baseUrl}/rides/${rideId}/photos`);
  }

  getRidesCounts(): Observable<Generic<{ activeRides: number; totalSharingRides: number; totalRentalRides: number; totalReservations: number }>> {
    return this.http.get<Generic<{ activeRides: number; totalSharingRides: number; totalRentalRides: number; totalReservations: number }>>(
      `${this.baseUrl}/rides/counts`
    );
  }

  getVerificationStats(): Observable<Generic<{ pending: number, approved: number, rejected: number}>> {
    return this.http.get<Generic<{ pending: number, approved: number, rejected: number}>>(
      `${this.baseUrl}/rides/photos/statistics`
    );
  }

  exportRides(params?: Params): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/rides/export`, {
      params: this.addParamsService.addParams(params),
      responseType: 'blob',
    });
  }
}
